import { useEffect } from "react";
import { setDocumentTitle } from "@/lib/documentTitle";
import { K1DashboardProvider } from "@/features/K1Dashboard/context/K1DashboardProvider";
import IssuersView from "@/features/K1Dashboard/views/IssuersView";

export default function K1Issuers() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Issuers");
  }, []);

  return (
    <K1DashboardProvider>
      <main className="min-h-0 flex flex-1 flex-col overflow-auto bg-white p-5">
        <IssuersView />
      </main>
    </K1DashboardProvider>
  );
}
